import { getURL } from "shelving";
import { CopyText, Page } from "shared/react";
import { type CreatorEntity, getGroupPath } from "shared/schema";
import { EntityHeader } from "../entity/EntityHeader.js";
import { useGroupContext } from "./GroupContext.js";
import { InviteList } from "./InviteList.js";

export function InvitePage(): React.ReactElement {
	const group = useGroupContext();
	const { id: gid } = group;
	const path = getURL(getGroupPath(group));
	const creator: CreatorEntity = `group:${gid}`;
	return (
		<Page title="Invite" path="./invite">
			<EntityHeader entity={creator}>
				<h1>Invite member</h1>
			</EntityHeader>
			<section className="space-2x">
				<h2 className="smush">Invite link</h2>
				<p className="smush color-quiet">Share a link for users to join this group.</p>
				<CopyText copy={path.href} />
			</section>
			<hr />
			<section className="space-2x">
				<h2 className="smush">Invite users</h2>
				<p className="smush color-quiet">Invite users who follow you to join this group.</p>
				<section>
					<InviteList gid={gid} />
				</section>
			</section>
		</Page>
	);
}
